import { useRef, useCallback } from 'react';
function useForceUpdate() {
    const [, updateState] = React.useState();
    return React.useCallback(() => updateState({}), []);
}
export function usePropsValue({ value, defaultValue, finalValue, onChange = (value) => { }, }) {
    const forceUpdate = useForceUpdate();
    const dfValue = (defaultValue !== undefined ? defaultValue : finalValue);
    const stateRef = useRef(value !== undefined ? value : dfValue);
    if (value !== undefined) {
        stateRef.current = value;
    }
    const setState = useCallback((v, forceTrigger = false) => {
        const prevState = stateRef.current;
        stateRef.current = v;
        if (prevState !== stateRef.current || forceTrigger) {
            forceUpdate();
            onChange?.(v);
        }
    }, [value, onChange]);
    return [stateRef.current, setState];
}
